/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionCustomerGranteesLegalIndicatorsQuery = gql`
  query GetSouscriptionCustomerGranteesLegalIndicatorsQuery($effectDate: String) {
    getSouscriptionCustomerGranteesLegalIndicators_souscription_customer_grantees(effectDate: $effectDate) {
      PASS 
      SMIC 
    }
  }
`;

export default GetSouscriptionCustomerGranteesLegalIndicatorsQuery;
